import {draw} from "./systems/present";
import {AppState} from "./app";
import {runLoop} from "./engine/utils/runLoop";
import {initScene} from "./systems/initScene";
import {initApp} from "./systems/initApp";
import {updateAnimationPlayer} from "./systems/updateAnimationPlayer";
import {updateCanvas} from "./systems/updateCanvas";
import {updateInput} from "./systems/updateInput";
import {updateAudio} from "./systems/updateAudio";
import {updateState} from "./systems/updateState";
import {updatePhysics} from "./systems/updatePhysics";
import {updateSprites} from "./systems/updateSprites";
import {preload} from "./systems/preload";
import {updatePointer} from "./systems/updatePointer";

declare global {
    interface Window {
        game: AppState;
        io: any
    }
}

function hideLoader() {

    document.querySelector<HTMLElement>(".loader").style.display = "none"
}


const appState: AppState = {} as AppState

window.game = runLoop({
    init: [ preload, initApp, initScene, hideLoader],
    simulate: [updateCanvas, updateInput, updateState, updatePhysics, updateAnimationPlayer, updateAudio],
    present: [updateSprites, updatePointer, draw]
}, appState)


